/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  CloseIsolatedPositionOptions,
  CloseIsolatedPositionStatus201,
  CloseIsolatedPositionStatus400,
  CloseIsolatedPositionStatus401,
  CloseIsolatedPositionStatus404,
  CloseIsolatedPositionStatus500,
} from '../types/CloseIsolatedPosition'
import type { UseMutationOptions, UseMutationResult, QueryClient } from '@tanstack/react-query'
import { closeIsolatedPosition } from '../clients/closeIsolatedPosition'
import { mutationOptions, useMutation } from '@tanstack/react-query'

export const closeIsolatedPositionMutationKey = () => [{ url: '/v1/positions/close' }] as const

export function closeIsolatedPositionMutationOptions<TContext = unknown>(
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const mutationKey = closeIsolatedPositionMutationKey()
  return mutationOptions<
    CloseIsolatedPositionStatus201,
    ResponseErrorConfig<
      | CloseIsolatedPositionStatus400
      | CloseIsolatedPositionStatus401
      | CloseIsolatedPositionStatus404
      | CloseIsolatedPositionStatus500
    >,
    CloseIsolatedPositionOptions,
    TContext
  >({
    mutationKey,
    mutationFn: async ({ body }) => {
      return closeIsolatedPosition({ ...config, body, throwOnError: true }).unwrap()
    },
  })
}

/**
 * @summary Close isolated positions, repaying the borrowed
 * {@link /v1/positions/close}
 */
export function useCloseIsolatedPosition<TContext>(
  options: {
    mutation?: UseMutationOptions<
      CloseIsolatedPositionStatus201,
      ResponseErrorConfig<
        | CloseIsolatedPositionStatus400
        | CloseIsolatedPositionStatus401
        | CloseIsolatedPositionStatus404
        | CloseIsolatedPositionStatus500
      >,
      CloseIsolatedPositionOptions,
      TContext
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey = mutationOptions.mutationKey ?? closeIsolatedPositionMutationKey()

  const baseOptions = closeIsolatedPositionMutationOptions(config) as UseMutationOptions<
    CloseIsolatedPositionStatus201,
    ResponseErrorConfig<
      | CloseIsolatedPositionStatus400
      | CloseIsolatedPositionStatus401
      | CloseIsolatedPositionStatus404
      | CloseIsolatedPositionStatus500
    >,
    CloseIsolatedPositionOptions,
    TContext
  >

  return useMutation<
    CloseIsolatedPositionStatus201,
    ResponseErrorConfig<
      | CloseIsolatedPositionStatus400
      | CloseIsolatedPositionStatus401
      | CloseIsolatedPositionStatus404
      | CloseIsolatedPositionStatus500
    >,
    CloseIsolatedPositionOptions,
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    CloseIsolatedPositionStatus201,
    ResponseErrorConfig<
      | CloseIsolatedPositionStatus400
      | CloseIsolatedPositionStatus401
      | CloseIsolatedPositionStatus404
      | CloseIsolatedPositionStatus500
    >,
    CloseIsolatedPositionOptions,
    TContext
  >
}
